/* SessionStatusInline.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17lj8p1Y8M%7B-moz-column-gap%3Avar(--ds-space-050%2C4px)%3Bcolumn-gap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@atlaskit/primitives/compiled';
import { RovoThinkingIndicator } from '../loading-state/thinking-indicator/ThinkingIndicator';
import { messages } from './messages';
import { SessionStatusIcon, type SessionStatus, type SessionStatusIconSize } from './SessionStatusIcon';
const styles = {
  status: "_3iDTPbccYA _0hPCNLDIqT _17lj8p1Y8M _3YEZNOdnbC _1ANEUSLRg7"
};
export type SessionStatusInlineStatus = SessionStatus | 'thinking';
export type SessionStatusInlineProps = {
  status: SessionStatusInlineStatus;
  /** Whether to render the needs-input icon alongside its text. */
  showIcon?: boolean;
  /** Visual size for the needs-input icon. Defaults to 12. */
  iconSize?: SessionStatusIconSize;
  /** Whether the thinking agent is the default Rovo agent. Defaults to true. */
  isDefaultAgent?: boolean;
  /** Text size for the thinking status. Defaults to the regular body size. */
  textSize?: 'default' | 'small';
  testId?: string;
};

/** Renders a compact semantic status suitable for a session-details list. */
export const SessionStatusInline = ({
  status,
  showIcon = true,
  iconSize = 12,
  isDefaultAgent = true,
  textSize = 'default',
  testId
}: SessionStatusInlineProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  if (status === 'thinking') {
    return <Box as="span" xcss={styles.status}>
				<RovoThinkingIndicator title={formatMessage(isDefaultAgent ? messages.rovoIsThinking : messages.agentIsThinking)} animation icon={false} disableMorphingAnimation showEllipsis={false} textSize={textSize} testId={testId} />
			</Box>;
  }
  return <Box as="span" xcss={styles.status} testId={testId}>
			{showIcon ? <SessionStatusIcon status={status} iconSize={iconSize} /> : null}
			{formatMessage(messages.needsInput)}
		</Box>;
};